import { GuidT } from '@/types/common';
import { PhotoAdvicesIF } from '@/components/widgets/AddPhotoWidget/FullTipsBottomSheet/FullTipsBottomSheet.types';

export const PHOTO_ADVICES: PhotoAdvicesIF[] = [
    {
        title: 'Подготовка одежды',
        items: [
            {
                subtitle: 'Одно изделие — один кадр.',
                description:
                    'Пожалуйста, загружайте вещи по отдельности, чтобы нейросеть не запуталась.',
            },
            {
                subtitle: 'Расправьте складки.',
                description:
                    'Постарайтесь разложить изделие ровно: так будет проще распознать длину, форму, карманы или воротник.',
            },
            {
                subtitle: 'Только само изделие.',
                description:
                    'Будет здорово, если на фото не будет людей или манекенов — только одежда на ровной поверхности.',
            },
            {
                subtitle: 'Обувь и аксессуары.',
                description:
                    'Обувь лучше снимать сразу парой, а сумочки и аксессуары — по одной штуке.',
            },
        ],
    },
    {
        title: 'Фон и свет',
        items: [
            {
                subtitle: 'Игра на контрасте.',
                description:
                    'Светлые изделия лучше фотографировать на тёмном фоне, а тёмные — на светлом. Главное, чтобы фон был однотонным.',
            },
            {
                subtitle: 'Ничего лишнего.',
                description:
                    'Пожалуйста, уберите из кадра посторонние предметы, чтобы в фокусе оставалось только ваше изделие.',
            },
            {
                subtitle: 'Мягкий свет.',
                description:
                    'Снимайте при естественном дневном свете. И лучше без фильтров — так мы точнее передадим настоящий цвет.',
            },
        ],
    },
    {
        title: 'Как правильно снимать.',
        items: [
            {
                subtitle: 'Камера прямо.',
                description:
                    'Старайтесь держать телефон ровно перед изделием, без сильного наклона.',
            },
            {
                subtitle: 'В полный рост.',
                description:
                    'Убедитесь, что изделие полностью помещается в кадр и не обрезается по краям.',
            },
            {
                subtitle: 'Немного воздуха.',
                description:
                    'Оставьте немного свободного места вокруг изделия со всех сторон.',
            },
        ],
    },
];

export const IMAGE_GUID: GuidT = '6c3f4260-70fa-48cd-994c-a26a6dbe93fb';
